import { useEffect } from "react";

export default function JsonLd({ id, data }: { id: string; data: object }) {
  useEffect(() => {
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = id;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.text = JSON.stringify(data);
    return () => {
      script?.remove();
    };
  }, [data, id]);

  return null;
}
